import React from 'react';
import {RxDatagrid, FilterField} from 'reactis-datagrid';
import {Button} from 'react-bootstrap';
import {connect} from 'react-redux';
import {getWindowSize} from '../utils/utils';

@connect((state, ownProps) => {
		return {
			state: state.datagrids.get(ownProps.id)
		};
	}, null, null, {withRef:true})
class Datagrid extends React.Component {

	static defaultProps = {
		alt: 'Obnovit',
		disableButtons: false
	};

	refresh() {
		return this.refs.datagrid.getWrappedInstance().refresh();
	}

	getQueryObject() {
		return this.refs.datagrid.getWrappedInstance().getQueryObject();
	}

	saveInline(apiMethod, field, args, cellValue) {
		return this.refs.datagrid.getWrappedInstance().saveInline(apiMethod, field, args, cellValue);
	}

	setInline(field, args, cellValue) {
		return this.refs.datagrid.getWrappedInstance().setInline(field, args, cellValue);
	}

  resetSelection() {
    return this.refs.datagrid.getWrappedInstance().resetSelection();
  }



	getLines() {
		let lines = Math.round((getWindowSize().height - 260) / 28);
		if (lines < 15) {
			lines = 15;
		}
		if (this.props.limit) {
			lines = this.props.limit;
		}
		return lines;
	}

	render() {

		const loading = this.props.state && this.props.state.get('pending') ? 'rotate' : '';

		const filters = this.props.filters ? this.props.filters.map(name => {
			return <FilterField key={name} filter={this.props.filter} field={name} style={{marginLeft: 10, float:'right'}} />
		}).reverse() : false;

		const view = this.props.view ? this.props.view.map(name => {
			return <FilterField key={name} filter={this.props.viewManager} field={name} style={{float:'left'}} />
		}).reverse() : false;


		const getRowClassName = (row) => {
			if (typeof row.active == 'undefined') {
				return;
			}
			return !row.active ? 'archive' : null;
		};

		return (
			<div className={this.props.className}>
				{!this.props.disableButtons &&
				<div className="dgtoolbar vp-tablet">
					{filters}
					<Button onClick={() => this.refresh()} title={this.props.alt} style={{float:'right', marginRight: 0}}>
						<i className={'fa fa-refresh ' + loading} style={{fontSize: 15}} />
					</Button>
					<div style={{float:'left'}}>
						{this.props.buttons}
					</div>
					<div style={{float:'left'}}>
						{view}
					</div>
					<div className="clearfix" />
				</div>}
				{this.props.header}
				<RxDatagrid ref="datagrid"
							getRowClassName={getRowClassName}
							{...this.props}
							compact={this.props.compact || getWindowSize().width < 700}
							limit={this.getLines()} />
			</div>
		)
	}
}

export default Datagrid;



// WEBPACK FOOTER //
// ./src/components/Datagrid.js